<template>
  <v-app-bar dark color="light-blue lighten-1" :clipped-left="$vuetify.breakpoint.lgAndUp" app>
    <!-- boton del sidebar -->
    <v-app-bar-nav-icon @click.stop="cambiarEstadoSidebar()"></v-app-bar-nav-icon>

    <!-- titulo del sistema -->
    <v-toolbar-title>{{titulo}}</v-toolbar-title>

    <!-- espaciador entre la parte izquierda y la derecha -->
    <v-spacer></v-spacer>

    <!-- notificaciones -->
    <Notificaciones></Notificaciones>

    <!-- Menu de usuario y cerrar sesion -->
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on">
          <EmpleadoJerarquia :usuario="vista.usuario"></EmpleadoJerarquia>
          <v-icon class="ml-1">mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-subheader>Usuario</v-subheader>
        <v-list-item-group color="primary">
          <v-list-item @click="cerrarSesion()">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Cerrar sesión</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>

    <!-- <v-btn text >Cerrar sesión</v-btn> -->
  </v-app-bar>
</template>

<script>
import EmpleadoJerarquia from "../empleado/EmpleadoJerarquia";
import Notificaciones from "../layout/Notificaciones";

export default {
  props: {
    titulo: "",
  },
  components: {
    EmpleadoJerarquia,
    Notificaciones,
  },
  data() {
    return {
      vista: {
        usuario: {
          jerarquiaId: this.$store.usuario.jerarquiaId,
          nombre: this.$store.usuario.nombre,
        },
      },
    };
  },
  methods: {
    cambiarEstadoSidebar() {
      this.$store.sidebar.active = !this.$store.sidebar.active;
    },
    cerrarSesion() {
      this.$auth.logout();
    },
  },
  mounted() {},
};
</script>